import { css } from '@emotion/react'

import { breakpoint, size } from '@twisto/styles'

export const primaryContainer = css`
  display: grid;
  grid-row-gap: ${size[20]};
  padding: 0 ${size[24]};
  margin: ${size[24]} 0;
`

export const secondaryContainer = css`
  display: grid;
  width: 100%;
  justify-items: stretch;
  grid-row-gap: ${size[16]};
  padding: 0 ${size[24]};
  margin: 0;

  ${breakpoint.down('smMd')} {
    a {
      width: 100%;
    }
  }
`
